import * as React from 'react';
import Modal from '@mui/material/Modal';
import { Button, Grid, makeStyles, Paper } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import { arrayMove } from 'react-sortable-hoc';
import ReorderComponent from '../../common/ReorderComponent';
import { showProgress } from '../../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import service from '../../../apis/service';
import { ErrorToast, notifySuccess } from '../../utils/Utils';
import useCategory from '../hooks/useCategory';

const useStyle = makeStyles({
  headerConatiner: {
    width: '389px',
    height: '42px',
    background: 'white',
  },
  header: {
    fontFamily: 'Lato',
    fontWeight: '600',
    fontSize: '20px',
  },
  content: {
    height: '65vh',
    overflowY: 'auto',
    background: '#f3f4f7',
    padding: '20px 10px',
  },
  saveButton: {
    width: '57px',
    height: '32px',
    padding: '8px 16px 8px 16px',
    gap: '10px',
    borderRadius: '4px',
    background: '#622FEE',
    color: 'white',
    marginRight: '6px',
    fontFamily: 'Lato',
    fontWeight: '600',
    fontSize: '12',
  },
  cancelButton: {
    width: '57px',
    height: '32px',
    padding: '8px 16px 8px 16px',
    gap: '10px',
    borderRadius: '4px',
    background: '#FEFEFE',
    color: '#10182B',
    marginRight: '6px',
    fontFamily: 'Lato',
    fontWeight: '600',
    fontSize: '12',
  },
  buttonContainer: {
    marginTop: 'auto',
    background: '#FFFFFF',
    width: '527px',
    height: '64px',
    border: '1px',
  },
});

export default function ReorderPopup({ isOpen, handleClose, categoryId, reorderType, deptId }) {
  const classes = useStyle();
  const dispatch = useDispatch();
  const { fetchPartnerTypes } = useCategory();
  const [arr, setArr] = React.useState([]);
  const [endPoint, setEndPoint] = React.useState();
  const content = useSelector((state) => state.categoryData.selectedCategoryDeptCollections);
  const selectedId = useSelector((state) => state.categoryData.selectedId);

  React.useEffect(() => {
    const deptArr = content?.departments?.find((dept) => dept.id === deptId);

    const collectionList = deptArr?.categories?.find((cat) => cat.id === categoryId)?.collections;
    if (reorderType === 'Reorder Collections') {
      const temp = collectionList?.map((item, index) => ({ ...item, seqId: index + 1 })) || [];
      setArr({ items: temp });
      setEndPoint(apiEndpoints.CAT_COLLECTION_REORDER);
    } else {
      const temp = deptArr?.categories?.map((item, index) => ({ ...item, seqId: index + 1 })) || [];
      setArr({ items: temp });
      setEndPoint(apiEndpoints.CAT_CATEGORY_REORDER);
    }
  }, [content, reorderType]);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setArr(({ items }) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
  };
  const handleSave = async () => {
    let payload = {};
    if (reorderType === 'Reorder Categories') {
      payload = {
        departmentId: deptId,
        rockedNetworkPartnerId: content?.rockedNetworkPartnerId,
        exploreCategoryIds: arr?.items.flatMap((item) => item.id),
      };
    } else {
      payload = {
        exploreCategoryId: categoryId,
        collectionIds: arr?.items.flatMap((item) => item.id),
      };
    }
    dispatch(showProgress(true));
    try {
      await service.post(endPoint, payload);
      notifySuccess('Collection added successfully');
      fetchPartnerTypes(selectedId);
    } catch (error) {
      ErrorToast(error);
    }
    handleClose();
    dispatch(showProgress(false));
  };
  return (
    <div>
      <Modal
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Paper
          elevation={3}
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '400px',
            borderRadius: '16px',
            padding: '16px',
          }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            className={classes.headerConatiner}
          >
            <Grid item>
              <Grid item className={classes.header}>
                {reorderType}
              </Grid>
            </Grid>
            <Grid item>
              <Close onClick={handleClose} style={{ cursor: 'pointer' }} />
            </Grid>
          </Grid>
          <Grid container direction="column">
            <Grid item style={{ height: '50vh', overflow: 'auto' }}>
              <ReorderComponent
                items={arr.items}
                onSortEnd={onSortEnd}
                enableSub
                type={reorderType === 'Reorder Collections' ? 'Collection' : 'Category'}
              />
            </Grid>
          </Grid>

          <Grid container justifyContent="flex-end" style={{ height: '100%' }}>
            <Grid item className={classes.buttonContainer}>
              <Grid container direction="row" alignItems="center" justifyContent="flex-end" style={{ height: '100%' }}>
                <Grid item spacing={2}>
                  <Button variant="contained" className={classes.cancelButton}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <Button variant="contained" className={classes.saveButton} onClick={handleSave}>
                    Save
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    </div>
  );
}
